// extracted by mini-css-extract-plugin
export default {"imageWrapper":"fP-z","twoColumnImage":"gP-z"};